module.exports = __webpack_public_path__ + "static/img/group-sucess.b3f0db2.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/group-sucess.svg
// module id = rimP
// module chunks = 1